// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type LatestPageTypeContextProperties = {
  page_type: string;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/latest_page_type_context/jsonschema/1-0-0';
export const latestPageTypeContextName = 'latest_page_type_context';
export class LatestPageTypeContext extends BaseTrackingContext<LatestPageTypeContextProperties> {
  constructor(properties: LatestPageTypeContextProperties) {
    super(latestPageTypeContextName, schema, properties);
  }
}
